import React from 'react';
import PropTypes from 'prop-types';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha";
import storeLayout from './default_layout'
import ReactOnRails from 'react-on-rails';

const styles = theme => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3,
    },
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
  },
  form: {
    marginTop: theme.spacing.unit * 2,
  }
})

class Panel extends React.Component {

  state = {
    name: { message: null, value: null},
    company: { message: null, value: null},
    email: { message: null, value: null},
    message: { message: null, value: null},
    reference: { message: null, value: null},
    otherReference: { message: null, value: null},
    formSubmitted: false,
    captcha: { message: null, value: null},
  }

  onReCaptchaChange = (value) => {
    this.setState({
      'captcha': { message: null, value: value }
    })
  }

  handleInput = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    if (value != null) {
      this.setState({
        [name]: { value: value, message: null }
      })
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const contact = { }
    contact.name = this.state.name.value
    contact.company = this.state.company.value
    contact.email = this.state.email.value
    contact.message = this.state.message.value
    contact.captcha = this.state.captcha.value
    contact.reference = this.state.reference.value == 'Other:' ? this.state.otherReference.value : this.state.reference.value

    axios.post('/contact_us',
      { contact_us: contact,
      }).then( response => {
        this.setState({formSubmitted: true})
      })
      .catch( error => {
        if(error.response){
          var errorData = error.response.data
          Object.keys(errorData).map(
            key => this.setState({[key]: { ...this.state[key], message: errorData[key][0] }})
          )
        }
      })
  }

  render () {
    const { classes, ref_list } = this.props;

    if (this.state.formSubmitted) {
      return (
        <div className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h4" variant="h4" align="left">
              Thank you
            </Typography>
            <Typography variant="h6" gutterBottom>
              <p>Thank you for completing the contact us form. The information you entered has been forwarded to our staff.</p>
            </Typography>
          </Paper>
        </div>
      )
    } else {
      return (
        <div className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h5" variant="h5" align="left">
              Contact Us
            </Typography>
            <form autoComplete="off" onSubmit={this.handleSubmit} className={classes.form}>
              <Grid container spacing={24}>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="name"
                    name="name"
                    label="Name"
                    error={this.state.name.message != null}
                    onChange={this.handleInput}
                    fullWidth
                    helperText={this.state.name.message}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="company"
                    name="company"
                    label="Company"
                    error={this.state.company.message != null}
                    onChange={this.handleInput}
                    helperText={this.state.company.message}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl} fullWidth={true} error={this.state.reference.message != null}>
                    <InputLabel htmlFor="reference">How did you hear about us? *</InputLabel>
                    <Select
                      value={(this.state.reference.value == null) ? '' : this.state.reference.value}
                      onChange={this.handleInput}
                      inputProps={{ name: 'reference', id: 'reference', }}
                    >

                    {ref_list.map((reference, index) =>
                      <MenuItem key={index} value={reference}>{reference}</MenuItem>
                    )}
                    </Select>
                    <FormHelperText>{this.state.reference.message}</FormHelperText>
                  </FormControl>
                </Grid>

                { this.state.reference.value != 'Other:' ? null :
                    <Grid item xs={12}>
                      <TextField
                        required={this.state.reference.value != 'Other:'}
                        id="otherReference"
                        name="otherReference"
                        label="Please specify"
                        onChange={this.handleInput}
                        fullWidth
                      />
                    </Grid>
                }
                <Grid item xs={12}>
                  <TextField
                    required
                    id="email"
                    name="email"
                    label="Email"
                    error={this.state.email.message != null}
                    onChange={this.handleInput}
                    helperText={this.state.email.message}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="message"
                    name="message"
                    label="Message"
                    multiline={true}
                    rows={9}
                    rowsMax={27}
                    error={this.state.message.message != null}
                    onChange={this.handleInput}
                    helperText={this.state.message.message}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl required error={this.state.captcha.message != null}>
                    <ReCAPTCHA
                      sitekey="6Ldk_PwSAAAAADky2JA2O2o9_TV2f2cciL8JB2Mn"
                      onChange={this.onReCaptchaChange}
                      required
                    />
                    <FormHelperText>{this.state.captcha.message}</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
              <div className={classes.buttons}>
                <Button
                  variant="contained"
                  type="submit"
                  value="Submit"
                  className={classes.button}
                >
                  Submit 
                </Button>
              </div>
            </form>
          </Paper>
        </div>
      )
    }
  }
}

Panel.propTypes = {
  classes: PropTypes.object.isRequired,
};

const ContactUs = withStyles(styles)(Panel);
export default ContactUs;
ReactOnRails.register({ ContactUs });
